import React from 'react';

const TicketIcon = (props) => {
    return (
        <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M17.625 3.64345e-06H0.375046C0.167874 3.64345e-06 0 0.191859 0 0.42848V2.99993C0 3.11358 0.039552 3.22263 0.109865 3.30299C0.180178 3.38335 0.275601 3.42855 0.375046 3.42855C1.17888 3.42855 1.92167 3.91874 2.32359 4.71428C2.72551 5.50981 2.72551 6.49019 2.32359 7.28572C1.92167 8.08126 1.17888 8.57145 0.375046 8.57145C0.167874 8.57145 0 8.7633 0 9.00007V11.5715C0 11.6852 0.039552 11.7941 0.109865 11.8746C0.180178 11.9549 0.275601 12 0.375046 12H17.625C17.7244 12 17.8198 11.9549 17.8901 11.8746C17.9604 11.7941 18 11.6852 18 11.5715V9.00007C18 8.88642 17.9604 8.77737 17.8901 8.69701C17.8198 8.61665 17.7244 8.57145 17.625 8.57145C16.8211 8.57145 16.0783 8.08126 15.6764 7.28572C15.2745 6.49019 15.2745 5.50981 15.6764 4.71428C16.0783 3.91874 16.8211 3.42855 17.625 3.42855C17.7244 3.42855 17.8198 3.38335 17.8901 3.30299C17.9604 3.22263 18 3.11358 18 2.99993V0.42848C18 0.31483 17.9604 0.205918 17.8901 0.125417C17.8198 0.0450591 17.7244 3.64345e-06 17.625 3.64345e-06ZM17.2499 2.59801H17.25C16.2743 2.73763 15.4205 3.41478 14.9646 4.41051C14.5088 5.40611 14.5088 6.59397 14.9646 7.58952C15.4205 8.58522 16.2743 9.2624 17.25 9.40203V11.1429H0.749702V9.40203C1.72541 9.2624 2.57922 8.58526 3.03514 7.58952C3.49093 6.59393 3.49093 5.40607 3.03514 4.41051C2.57922 3.41481 1.72544 2.73764 0.749702 2.59801V0.857104H17.25L17.2499 2.59801Z"
                fill="black"
            />
            <path
                d="M6.83036 10.0676C7.06153 10.2017 7.35582 10.12 7.48802 9.88536L11.345 3.02854C11.4122 2.91555 11.4315 2.77993 11.3988 2.65218C11.3662 2.52459 11.2841 2.41571 11.1715 2.35028C11.0586 2.28484 10.9246 2.26828 10.7999 2.30452C10.6749 2.34077 10.5698 2.42653 10.508 2.54264L6.65102 9.39946C6.51897 9.6343 6.59936 9.93342 6.83036 10.0676Z"
                fill="black"
            />
            <path
                d="M12.375 7.1935C12.375 7.73451 11.9432 8.17318 11.4106 8.17318C10.8781 8.17318 10.4464 7.73451 10.4464 7.1935C10.4464 6.65249 10.8781 6.21399 11.4106 6.21399C11.9432 6.21399 12.375 6.65249 12.375 7.1935Z"
                fill="black"
            />
            <path
                d="M7.55358 5.23462C7.55358 5.77564 7.12193 6.21413 6.58937 6.21413C6.05681 6.21413 5.625 5.77564 5.625 5.23462C5.625 4.69361 6.05681 4.25494 6.58937 4.25494C7.12193 4.25494 7.55358 4.69361 7.55358 5.23462Z"
                fill="black"
            />
        </svg>
    );
};

export default TicketIcon;
